import { IEvent } from "@Interfaces";
import { IEventModule } from "@Modules/eventPage/root/IEventModule";
import { URL_SEARCH_PARAMS } from "repoV2/constants/urls&routing/urlParams";
import { checkIsDefined } from "src/features/Common/modules/DataTypes/utils/nanNullUndef";
import { isDefaultNotSelectedInOfferingVariations } from "../../OfferingVariationSelector/OfferingVariationSelector.utils";

export const getHideEarlyBird = ({
    disablePayment,
    earlyBirdObj = {} as IEvent.IEarlyBird,
    urlQueryParams = {},
    eventData,
}: {
    disablePayment: boolean;
    earlyBirdObj: IEvent.IEarlyBird | null;
    urlQueryParams?: IEventModule.IProps["urlQueryParams"];
    eventData?: IEvent.IEventData;
}) => {
    return (
        disablePayment ||
        !checkIsDefined(earlyBirdObj?.price) ||
        isDefaultNotSelectedInOfferingVariations(eventData) ||
        urlQueryParams[URL_SEARCH_PARAMS.COMMUNITY_ID]
    );
};
